import React from "react";

const cx = (...a) => a.filter(Boolean).join(" ");

/**
 * Alegerea lipită (ca Cutie Manual/Automat): 2–6 opțiuni pe un rând, una aleasă.
 * Opțiunea aleasă e pastila accent (rază 30); celelalte sunt lipite, cu rază 30
 * spre margine și 8 spre interior (cea din mijloc: 8 peste tot).
 *
 * value: unul din options[].value
 * options: [{ value, label, disabled?, dot? }] — `disabled` oprește doar opțiunea
 *    aceea; `dot` pune punctul de „așteaptă răspuns” lângă text (ca la Chat →
 *    Conversații); un text în loc de `true` devine eticheta punctului
 * variant: implicit opțiunile sunt black-s (pe un card black-p) |
 *    "tabs" = filele lipite din popup-uri: black-p (pe panoul black-s), 3px între ele
 * size: "sm" = filele mai joase (Profil elev → Examene: Teorie / Practică)
 */
export default function SegmentedToggle({
   name,
   value,
   options = [],
   onChange,
   disabled = false,
   variant,
   size,
   className = "",
   "aria-label": ariaLabel,
}) {
   const list = Array.isArray(options) ? options.filter(Boolean).slice(0, 6) : [];
   if (list.length < 2) return null;

   return (
      <div
         className={cx(
            "segmentedToggle",
            variant === "tabs" && "segmentedToggle--tabs",
            size === "sm" && "segmentedToggle--sm",
            disabled && "is-disabled",
            className,
         )}
         role="group"
         aria-label={ariaLabel || name || "Opțiuni"}
      >
         {list.map((option) => {
            const checked = String(value) === String(option.value);
            const dotLabel = typeof option.dot === "string" ? option.dot : undefined;
            return (
               <label
                  key={String(option.value)}
                  className={cx(
                     "segmentedToggle__option",
                     checked && "is-active",
                     option.disabled && "is-disabled",
                  )}
               >
                  <input
                     type="radio"
                     name={name}
                     value={option.value}
                     checked={checked}
                     disabled={disabled || Boolean(option.disabled)}
                     onChange={() => onChange?.(option.value)}
                  />
                  <span className={cx("segmentedToggle__label", option.dot && "segmentedToggle__label--dot")}>
                     {option.dot ? <span className="segmentedToggle__text">{option.label}</span> : option.label}
                     {option.dot && (
                        <span
                           className="segmentedToggle__dot"
                           role={dotLabel ? "img" : undefined}
                           aria-label={dotLabel}
                           aria-hidden={dotLabel ? undefined : "true"}
                           title={dotLabel}
                        />
                     )}
                  </span>
               </label>
            );
         })}
      </div>
   );
}
